import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'; // Import icons from react-icons
import '../styles/LawDisplayPage.css';
// import { FamilyLaw } from '../../../backend/models/LawModels';

const FamilyLaw = () => {
  const navigate = useNavigate();
  const buttonContainerRef1 = useRef(null);
  const buttonContainerRef2 = useRef(null);

  const scrollLeft = (ref) => {
    ref.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = (ref) => {
    ref.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  return (
    <div className="law-page">
      {/* Heading */}
      <h1>Indian Family Law</h1>

      {/* Details of Indian Family Law */}
      <div className="content-section">
        <h2>Details of Indian Family Law</h2>
        <p>
        Indian Family Law is a branch of law that deals with legal issues related to families and domestic relationships, 
        including marriage, divorce, adoption, child custody, property division, maintenance, and more. 
        The purpose of Indian Family Law is to provide a framework for resolving disputes and protecting 
        the rights and interests of individuals involved in family law matters
        </p>
        <p>
        The laws can vary depending on the religion and community of the individuals involved in the family law matter. 
        Indian Family Law is enforced by the courts and provides individuals with the means to seek legal remedy in the event of a dispute.
        </p>
      </div>

      {/* First Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef1)} />
        <div className="button-container" ref={buttonContainerRef1}>
          <button className="big-button">Hindu family law</button>
          <button className="big-button" onClick={() => navigate('/family-law')}>
          Muslim Family Law
          </button>
          <button className="big-button">Christian Family Law</button>
          {/* <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button> */}
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef1)} />
      </div>

      {/* Second Row of Buttons */}
      <div className="button-row">
        <FaAngleDoubleLeft className="scroll-icon left" onClick={() => scrollLeft(buttonContainerRef2)} />
        <div className="button-container" ref={buttonContainerRef2}>
          <button className="big-button">Parsi Family law</button>
          <button className="big-button">Special Marriage Act</button>
          <button className="big-button">Property Law</button>
          <button className="big-button" onClick={() => navigate('/search')}>
            Search area
          </button>
        </div>
        <FaAngleDoubleRight className="scroll-icon right" onClick={() => scrollRight(buttonContainerRef2)} />
      </div>
    </div>
  );
};

// export default CivilLaw;
export default FamilyLaw;
